(function () {
  const IND_CLASS = "ml-swipe-indicator";
  const THUMB_CLASS = "ml-swipe-indicator__thumb";

  function ensureIndicator(slideshowEl) {
    let ind = slideshowEl.querySelector("." + IND_CLASS);
    if (ind) return ind;

    ind = document.createElement("div");
    ind.className = IND_CLASS;
    ind.innerHTML = `<span class="${THUMB_CLASS}"></span>`;
    slideshowEl.appendChild(ind);
    return ind;
  }

  function getSlides(slideshowEl) {
    return Array.from(slideshowEl.querySelectorAll("slideshow-slide"));
  }

  // Return null if we can't confidently find an active slide right now
  function activeIndexFromAria(slides) {
    const active = slides.find((s) => s.getAttribute("aria-hidden") === "false");
    if (!active) return null;
    const idx = slides.indexOf(active);
    return idx >= 0 ? idx : null;
  }

  function setThumbPx(ind, thumb, pct) {
    const clamped = Math.max(0, Math.min(1, pct));

    const trackW = ind.getBoundingClientRect().width;
    const thumbW = thumb.getBoundingClientRect().width;
    const maxX = Math.max(0, trackW - thumbW);
    const x = clamped * maxX;

    thumb.style.transform = `translateX(${x}px)`;
  }

  function attach(slideshowEl) {
    if (slideshowEl.dataset.mlSwipeBound === "1") return;
    slideshowEl.dataset.mlSwipeBound = "1";

    const slides = getSlides(slideshowEl);
    if (slides.length <= 1) return;

    const ind = ensureIndicator(slideshowEl);
    const thumb = ind.querySelector("." + THUMB_CLASS);
    if (!thumb) return;

    // Thumb width based on slide count (min 20%)
    const thumbPct = Math.max(0.2, 1 / slides.length);
    thumb.style.width = `${thumbPct * 100}%`;

    let lastIdx = 0;
    let rafId = 0;

    function doUpdate() {
      rafId = 0;

      const idx = activeIndexFromAria(slides);

      // KEY FIX: if we can't find an active slide (transient state mid-swipe),
      // do NOT snap to 0 — just keep the last known index.
      if (idx === null) return;

      lastIdx = idx;

      const maxIdx = slides.length - 1;
      const pct = maxIdx > 0 ? lastIdx / maxIdx : 0;
      setThumbPx(ind, thumb, pct);
    }

    function scheduleUpdate() {
      if (rafId) return;
      rafId = requestAnimationFrame(doUpdate);
    }

    // Observe aria-hidden changes (Clarity toggles this on swipe)
    const mo = new MutationObserver(scheduleUpdate);
    slides.forEach((s) =>
      mo.observe(s, { attributes: true, attributeFilter: ["aria-hidden"] })
    );

    // Safety updates after interactions
    slideshowEl.addEventListener("touchend", () => setTimeout(scheduleUpdate, 60), {
      passive: true,
    });
    slideshowEl.addEventListener("pointerup", () => setTimeout(scheduleUpdate, 60), {
      passive: true,
    });

    // Initial position (try a few times in case aria isn't ready yet)
    scheduleUpdate();
    setTimeout(scheduleUpdate, 100);
    setTimeout(scheduleUpdate, 250);
    setTimeout(scheduleUpdate, 500);
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll("slideshow-component").forEach(attach);
  }

  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", (e) => init(e.target));

  // Covers lazy-loaded / replaced nodes
  const obs = new MutationObserver(() => init(document));
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();


// ── Mobile: strip inline spacing-style padding from product detail group-blocks ──
(function() {
  function stripProductDetailPadding() {
    if (window.innerWidth >= 750) return;
    var blocks = document.querySelectorAll('.product-information .product-details .group-block.spacing-style, .product-information .product-details > .group-block');
    blocks.forEach(function(el) {
      el.style.removeProperty('--padding-block-start');
      el.style.removeProperty('--padding-block-end');
      el.style.removeProperty('--padding-inline-start');
      el.style.removeProperty('--padding-inline-end');
    });
  }

  document.addEventListener('DOMContentLoaded', stripProductDetailPadding);
  document.addEventListener('shopify:section:load', stripProductDetailPadding);
})();
